import { browser } from "$app/environment";
import posthog from "posthog-js";
import { isStaging, isProduction } from "$lib/utility/environment";

declare global {
  interface Window {
    dataLayer: any[];
  }
}

const unmaskedClass = "ph-unmasked";

const POSTHOG_ID_PROD = "phc_airg3loe7WkFy5EVg5bq3pYmJolyGQe4batp9azNS9q";
const POSTHOG_ID_STAGING = "phc_2diEBPxqhgHJ73BZRlIg6avjtngUVyc3nrd2Xso5tTu";

const GOOGLE_ANALYTICS_ID_PROD = "G-4JLVEYMZNB";

export function initPosthogAnalytics() {
  if (!browser) return;

  const maskingOptions = {
    maskAllInputs: true,
    maskInputFn: (text: string, element: HTMLElement | undefined) => {
      if (element?.getAttribute("class")?.includes(unmaskedClass)) {
        return text;
      }
      return "*".repeat(text.length);
    },
  };

  if (isStaging()) {
    logger.log("Initializing analytics (staging)");
    posthog.init(POSTHOG_ID_STAGING, {
      api_host: "https://us.i.posthog.com",
      person_profiles: "always",
      session_recording: {
        ...maskingOptions,
      },
    });
  } else if (isProduction()) {
    logger.log("Initializing analytics (production)");
    posthog.init(POSTHOG_ID_PROD, {
      api_host: "https://us.i.posthog.com",
      person_profiles: "always",
      ...maskingOptions,
    });
  }
}

export function initGoogleAnalytics() {
  if (!browser) return;
  if (isProduction()) {
    if (document.querySelector('script[src*="googletagmanager.com/gtm.js"]')) {
      return;
    }
    const script = document.createElement("script");
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-5TSPSDKT')`;

    document.head.insertBefore(script, document.head.firstChild);

    const noscript = document.createElement("noscript");
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5TSPSDKT"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

    if (document.body) {
      document.body.insertBefore(noscript, document.body.firstChild);
    } else {
      window.addEventListener("DOMContentLoaded", () => {
        document.body.insertBefore(noscript, document.body.firstChild);
      });
    }

    window.dataLayer = window.dataLayer || [];
  }
}

export function identifyUser(userId: string, properties?: Record<string, any>) {
  if (!browser) return;

  if (isStaging() || isProduction()) {
    posthog.identify(userId, properties);
  }
}

export function resetAnalytics() {
  if (!browser) return;

  if (isStaging() || isProduction()) {
    posthog.reset();
  }
}
